import { useAuthDataContext } from "components/auth";
import { getImgPathAsset, getImgPathCustomerAsset } from "config/paths";

export default asset => {
  const { token } = useAuthDataContext();
  return asset && asset.customerId ? getImgPathCustomerAsset(asset, token) : getImgPathAsset(asset, token);
};
